import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { format } from 'date-fns';
import jaLocale from 'date-fns/locale/ja';
import enLocale from 'date-fns/locale/en-US';
import Box from '@material-ui/core/Box';
import Pagination from '../../components/Pagination/Pagination';
import dateUtils from '../../utils/dateUtils';
import CustomTypography from '../../components/Typography/CustomTypography';
import GridItem from '../../components/Grid/GridItem';
import { navyColor } from '../../assets/jss/global';
import CustomTable from '../../components/Table/Table';
import Button from '../../components/Button/CustomButton';
import { LIVESTREAM_STATUS_START, PAID, statusType } from '../../common/Constants';
import { LoadMoreIcon } from '../../components/Icons/Icon';
import ViewHeader from '../../components/Header/ViewHeader';
import Loader from '../../components/Loader/Loader';
import Snackbar from '../../components/Snackbar/Snackbar';

export const Header = (props) => {
    const { eventInfo } = props;
    const intl = useIntl();
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={eventInfo?.settings_texts_sidebar_viewer?.field_name?.livestream_application_list
                        || intl.formatMessage({ id: 'userRoutes.liveStreamRegister' })}
                    isIntl={false}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const ListLivestreamRegistered = ({
    isLoading,
    listRegistered,
    listLivestream,
    getListRegisteredLivestream,
    clearListRegisteredLivestream,
    customText,
    customColor,
    eventInfo,
    locale,
}) => {
    const routeParams = useParams();
    const history = useHistory();
    const intl = useIntl();
    const [listRegisteredLivestream, setListRegisteredLivestream] = useState({});
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });

    useEffect(() => {
        clearListRegisteredLivestream();
        return () => {
            clearListRegisteredLivestream();
        };
    }, []);

    useEffect(() => {
        if (routeParams) {
            getListRegisteredLivestream({
                event_name: routeParams.shortName,
                language: locale,
            });
        }
    }, [routeParams, locale]);

    useEffect(() => {
        if (listLivestream) {
            setListRegisteredLivestream(listRegistered);
        }
    }, [listRegistered]);

    const createDataView = () => {
        const viewDataRegister = [];
        Object.keys(listRegisteredLivestream).forEach((key) => {
            createDateTitle(key);
            const viewTable = [];
            let tableData = [];
            tableData = Object.keys(listRegisteredLivestream[key]).map((index) => {
                const liveStream = listRegisteredLivestream[key][index];
                let statusPaid = '';
                if (+liveStream.cost > 0) statusPaid = liveStream.is_paid ? PAID[locale].PAIDED : PAID[locale].UNPAID;
                return [
                    <p>{`${liveStream.stime}~${liveStream.etime}`}</p>,
                    liveStream.title,
                    liveStream.content,
                    liveStream.speaker,
                    liveStream.cost === 0
                        ? intl.formatMessage({ id: 'common.free' })
                        : `${intl.formatNumber(liveStream.cost)}${intl.formatMessage({ id: 'common.yen' })}`,
                    statusPaid,
                    liveStream.cost ? statusType[locale][liveStream.status] : intl.formatMessage({ id: 'common.approve' }),
                    LIVESTREAM_STATUS_START[liveStream.status_live_stream_time] === 'RUNNING' && (
                        <Button
                            onClick={(e) => onViewLiveStream(e, liveStream.live_stream_time_id, liveStream.is_paid)}
                            color="navy"
                            style={{ fontSize: '14px' }}
                            buttonTextColor={customColor?.button_text_color}
                            buttonBackgroundColor={customColor?.button_background_color?.common_button}
                        >
                            {customText?.button_name?.watch_livestream || intl.formatMessage({ id: 'livestream.watchLivestream' })}
                        </Button>
                    ),
                ];
            });

            viewTable.push(createTable(key, tableData));
            const viewDate = (
                <React.Fragment key={key}>
                    {createDateTitle(key)}
                    {viewTable}
                </React.Fragment>
            );
            viewDataRegister.push(viewDate);
        });
        return viewDataRegister;
    };

    const createDateTitle = (dateTitle) => (
        <GridItem xs={12} style={{ margin: '20px 0 20px 0' }}>
            <CustomTypography bold variant="h5" customColor={customColor?.contents_text_color}>
                {intl.formatMessage({ id: 'common.date' })}
                {'  :  '}
                {dateUtils.formatJa(new Date(dateTitle), locale)}
            </CustomTypography>
        </GridItem>

    );

    const createTable = (key, viewlist) => {
        const tableHeader = [
            customText?.field_name?.delivery_time || intl.formatMessage({ id: 'livestream.deliveryTime' }),
            customText?.field_name?.title || intl.formatMessage({ id: 'common.title' }),
            customText?.field_name?.contents || intl.formatMessage({ id: 'livestream.deliveryContent' }),
            customText?.field_name?.performer || intl.formatMessage({ id: 'common.performer' }),
            customText?.field_name?.fee || intl.formatMessage({ id: 'price' }),
            customText?.field_name?.payment_status || intl.formatMessage({ id: 'seminar.paymentStatus' }),
            customText?.field_name?.approval_status || intl.formatMessage({ id: 'seminar.approvalStatus' }),
            customText?.field_name?.watch || intl.formatMessage({ id: 'livestream.watch' }),
        ];
        const tableHeaderWidth = ['10%', '14%', '20%', '10%', '7%', '10%', '10%', '20%'];
        return (
            <>
                <CustomTable
                    tableHead={tableHeader}
                    tableHeadWidth={tableHeaderWidth}
                    tableData={viewlist}
                    cellColor={customColor?.list_table?.title_background_color || navyColor}
                    hover={false}
                    cellTextColorHear={customColor?.list_table?.title_text_color}
                    cellTextColorBody={customColor?.contents_text_color}
                    cellBackgroundColor={customColor?.list_table}
                    key={key}
                />
            </>
        );
    };

    const onViewLiveStream = (e, id, isPaid) => {
        if (isPaid) {
            const { pathname } = history.location;
            const path = `${pathname}/${id}`;
            history.push(path);
        } else {
            setSnackbar({
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'livestream.notePaymentProcedure' }, {
                    namePage: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming || intl.formatMessage({ id: 'userRouters.liveStream' }),
                }),
            });
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const handleSearchWithPage = () => {
        getListRegisteredLivestream({ event_name: routeParams.shortName, page: listLivestream.page + 1 });
    };

    const handleSearchWithPageLayout1 = (changePage) => {
        getListRegisteredLivestream({ event_name: routeParams.shortName, page: changePage });
    };

    const createTableLayout1 = (dataRow) => (
        <>
            <CustomTable
                tableHead={[
                    customText?.field_name?.delivery_time || intl.formatMessage({ id: 'livestream.deliveryTime' }),
                    customText?.field_name?.title || intl.formatMessage({ id: 'common.title' }),
                    customText?.field_name?.contents || intl.formatMessage({ id: 'livestream.deliveryContent' }),
                    customText?.field_name?.performer || intl.formatMessage({ id: 'common.performer' }),
                    customText?.field_name?.fee || intl.formatMessage({ id: 'price' }),
                    customText?.field_name?.payment_status || intl.formatMessage({ id: 'seminar.paymentStatus' }),
                    customText?.field_name?.approval_status || intl.formatMessage({ id: 'seminar.approvalStatus' }),
                    customText?.field_name?.watch || intl.formatMessage({ id: 'livestream.watch' }),
                ]}
                tableHeadWidth={['10%', '14%', '20%', '10%', '7%', '10%', '10%', '20%']}
                tableData={dataRow}
                cellColor={customColor?.list_table?.title_background_color || '#edf4f7'}
                hover={false}
                cellTextColorHear={customColor?.list_table?.title_text_color || '#4b4b4b'}
                borderColor="#4b4b4b"
                cellTextColorBody={customColor?.contents_text_color}
                cellBackgroundColor={customColor?.list_table}
                tableFooter={(
                    <Box display="flex" justifyContent="center">
                        <Pagination
                            page={listLivestream.page}
                            total={listLivestream.total_page}
                            onChange={(changePage) => handleSearchWithPageLayout1(changePage)}
                            colorBackgroundCustom={customColor?.list_table?.odd_record_background_color}
                            colorTextCustom={customColor?.button_background_color?.common_button}
                        />
                    </Box>
                )}
            />
        </>
    );
    const createDataViewLayout1 = () => {
        const dataRow = listLivestream.results && listLivestream.results.map((liveStream) => {
            let statusPaid = '';
            if (+liveStream.cost > 0) statusPaid = liveStream.is_paid ? PAID[locale].PAIDED : PAID[locale].UNPAID;
            const date = format(
                new Date(liveStream.date),
                locale === 'en' ? 'MMMM dd (E)' : 'MM月dd日(E)',
                { locale: locale === 'en' ? enLocale : jaLocale },
            );
            const dateTime = (
                <>
                    <p>{date}</p>
                    <p>
                        {liveStream.stime}
                        ~
                        {liveStream.etime}
                    </p>
                </>
            );
            return [
                dateTime,
                liveStream.title,
                liveStream.content,
                liveStream.speaker,
                liveStream.cost === 0 ? intl.formatMessage({ id: 'common.free' }) : `${
                    intl.formatNumber(liveStream.cost)}${intl.formatMessage({ id: 'common.yen' })}`,
                statusPaid,
                liveStream.cost ? statusType[locale][liveStream.status] : intl.formatMessage({ id: 'common.approve' }),
                LIVESTREAM_STATUS_START[liveStream.status_live_stream_time] === 'RUNNING' && (
                    <Button
                        onClick={(e) => onViewLiveStream(e, liveStream.live_stream_time_id, liveStream.is_paid)}
                        color="navy"
                        style={{ fontSize: '14px' }}
                        buttonTextColor={customColor?.button_text_color}
                        buttonBackgroundColor={customColor?.button_background_color?.common_button}
                    >
                        {customText?.button_name?.watch_livestream || intl.formatMessage({ id: 'livestream.watchLivestream' })}
                    </Button>
                ),
            ];
        });
        return listLivestream.total_length ? createTableLayout1(dataRow) : <></>;
    };
    return (
        <div>
            <Loader isLoading={isLoading} />
            {!_.isEmpty(eventInfo) && (
                <>
                    <GridItem>
                        {eventInfo.layout_livestream ? createDataViewLayout1() : createDataView()}
                    </GridItem>
                    { !eventInfo.layout_livestream && (listLivestream.page < listLivestream.total_page) && (
                        <GridItem align="center">
                            <Button
                                onClick={handleSearchWithPage}
                                color="navy"
                                gradient
                                size="md"
                                round
                                buttonTextColor={customColor?.button_text_color}
                                buttonBackgroundColor={customColor?.button_background_color?.common_button}
                            >
                                <LoadMoreIcon />
                                {intl.formatMessage({ id: 'common.seeMore' })}
                            </Button>
                        </GridItem>
                    )}
                    {
                        !listLivestream.total_length && (
                            <GridItem
                                xs={12}
                                style={{
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    fontSize: '20px',
                                    zIndex: 1,
                                    color: customColor?.contents_text_color,
                                }}
                            >
                                <FormattedMessage id="noData" />
                            </GridItem>
                        )
                    }
                </>
            )}
            <Snackbar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
            />
        </div>
    );
};

ListLivestreamRegistered.defaultProps = {
    isLoading: false,
    listRegistered: {},
    listLivestream: {},
    getListRegisteredLivestream: () => {},
    clearListRegisteredLivestream: () => {},
    customText: {},
    customColor: {},
    eventInfo: {},
    locale: 'ja',
};

ListLivestreamRegistered.propTypes = {
    isLoading: PropTypes.bool,
    listRegistered: PropTypes.oneOfType([() => null, PropTypes.object]),
    listLivestream: PropTypes.oneOfType([() => null, PropTypes.object]),
    getListRegisteredLivestream: PropTypes.func,
    clearListRegisteredLivestream: PropTypes.func,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default ListLivestreamRegistered;
